// 🔒
export const termsOfServiceSections = [
  {
    id: 1,
    title: "Introduction",
    content: [
      "These Terms of Service govern your access to and use of our website, mobile application, and related services.",
      "By using the platform, you agree to be bound by these Terms of Service. If you do not agree, you should not use the platform."
    ]
  },
  {
    id: 2,
    title: "Use of the Platform",
    content: [
      "The platform is intended to provide access to fitness-related content, training programs, trainer profiles, digital services, and related features.",
      "You agree to use the platform only for lawful purposes and in a way that does not interfere with the operation, security, or integrity of the service."
    ]
  },
  {
    id: 3,
    title: "Account and Access",
    content: [
      "Certain features may require account registration or access through a supported app marketplace or authentication flow.",
      "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account."
    ]
  },
  {
    id: 4,
    title: "Programs and Fitness Content",
    content: [
      "The platform may provide access to workout programs, coaching materials, educational content, and trainer-created digital products.",
      "All fitness content is provided for general informational and training purposes only and does not replace professional medical advice, diagnosis, or treatment."
    ]
  },
  {
    id: 5,
    title: "Health Disclaimer",
    content: [
      "By using the platform, you acknowledge that physical exercise involves inherent risks and that participation in any training program is at your own risk.",
      "You should consult an appropriate medical professional before beginning any exercise, nutrition, or wellness program, especially if you have any medical condition, injury, or concern."
    ]
  },
  {
    id: 6,
    title: "Purchases and Payments",
    content: [
      "The platform may offer paid content, including digital programs, subscriptions, or other premium features.",
      "Purchases may be processed through third-party providers such as Apple App Store, Google Play, or other payment processors, and additional terms from those providers may apply."
    ]
  },
  {
    id: 7,
    title: "Refunds",
    content: [
      "Refund eligibility, if any, may depend on the payment platform used, applicable law, and the specific product or service purchased.",
      "Where purchases are made through app marketplaces, refund requests may need to be submitted directly through that marketplace provider."
    ]
  },
  {
    id: 8,
    title: "Trainer Content and Collaboration",
    content: [
      "Trainers who collaborate with the platform are responsible for the accuracy, quality, and legality of the content they provide.",
      "We reserve the right to review, format, adapt for technical presentation, approve, reject, suspend, or remove trainer content where necessary for product quality, safety, legal compliance, or platform standards."
    ]
  },
  {
    id: 9,
    title: "Intellectual Property",
    content: [
      "All platform design, branding, software, text, graphics, and original materials are protected by applicable intellectual property laws.",
      "Users and trainers may not copy, reproduce, distribute, modify, republish, or exploit platform content except as expressly permitted."
    ]
  },
  {
    id: 10,
    title: "Prohibited Conduct",
    content: [
      "You agree not to misuse the platform, attempt unauthorized access, interfere with service availability, reverse engineer the software, upload harmful material, or use the service in a fraudulent or abusive way.",
      "We may suspend or terminate access for users or collaborators who violate these Terms."
    ]
  },
  {
    id: 11,
    title: "Availability of Service",
    content: [
      "We aim to keep the platform available and functional, but we do not guarantee uninterrupted access, error-free operation, or permanent availability of any feature.",
      "We may modify, update, suspend, or discontinue parts of the platform at any time."
    ]
  },
  {
    id: 12,
    title: "Limitation of Liability",
    content: [
      "To the maximum extent permitted by law, the platform and its operators are not liable for indirect, incidental, special, consequential, or punitive damages arising out of or related to the use of the service.",
      "Use of the platform, programs, and fitness content is at your own risk."
    ]
  },
  {
    id: 13,
    title: "Termination",
    content: [
      "We may suspend or terminate access to the platform at our discretion where necessary for security, legal compliance, misuse prevention, or breach of these Terms.",
      "You may stop using the platform at any time."
    ]
  },
  {
    id: 14,
    title: "Changes to These Terms",
    content: [
      "We may update these Terms of Service from time to time to reflect changes in the platform, business model, or legal requirements.",
      "Updated terms may become effective when posted on the website or otherwise communicated through the platform."
    ]
  },
  {
    id: 15,
    title: "Governing Law",
    content: [
      "These Terms of Service are governed by the laws applicable to the operator of the platform, unless otherwise required by mandatory consumer protection law."
    ]
  },
  {
    id: 16,
    title: "Contact",
    content: [
      "If you have questions about these Terms of Service, you can contact us through the support or contact channels provided on the platform."
    ]
  }
];
// 🔒